// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2w-5i","detailsBorder":"styles_detailsBorder__16xOU"};